import ConfirmModal from '@/components/ConfirmModal';
import { TransText } from '@/i18n/trans/text';
import { Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface BookingExpiredDialogProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  onCancel: () => void;
  // When true, the lapsed session is a booking modification (change-booking)
  // rather than a new purchase — swap copy + the dismiss label accordingly.
  isChangeBooking?: boolean;
}

const BookingExpiredDialog: FC<BookingExpiredDialogProps> = ({
  open,
  setOpen,
  onCancel,
  isChangeBooking = false,
}) => {
  return (
    <ConfirmModal
      open={open}
      setOpen={setOpen}
      onCancel={onCancel}
      title={
        <Typography variant="subtitle">
          <TransText
            i18nKey={
              isChangeBooking ? 'changeSessionExpired' : 'bookingSessionExpired'
            }
          />
        </Typography>
      }
      description={
        <Typography variant="paragraph">
          <TransText
            i18nKey={
              isChangeBooking
                ? 'changeSessionExpiryDescription'
                : 'bookingSessionExpiryDescription'
            }
          />
        </Typography>
      }
      cancelLabel={isChangeBooking ? 'backToBooking' : 'backToJourneySearch'}
      showClose={false}
      interactOutside={false}
    />
  );
};

export default BookingExpiredDialog;
